import React, { useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useAuth } from "./auth/AuthContext";
import { ScrollToTop } from "./components/layout/ScrollToTop";
import { logPageLoad } from "./utils/analytics";
import { HomePage }          from "./pages/HomePage";
import { AuthPage }          from "./pages/AuthPage";
import { CbmCalculatorPage } from "./pages/CbmCalculatorPage";
import { BeyondCbmPage }     from "./pages/BeyondCbmPage";
import { ExamplesPage }      from "./pages/ExamplesPage";
import { PricingPage }       from "./pages/PricingPage";
import { DevelopersPage }    from "./pages/DevelopersPage";
import { ConsolePage }       from "./pages/ConsolePage";
import { CaseStudiesPage }   from "./pages/CaseStudiesPage";
import { ContactSalesPage }  from "./pages/ContactSalesPage";
import { SolutionsPage }     from "./pages/SolutionsPage";
import { TechnologyPage }    from "./pages/TechnologyPage";
import { SimulationPage }    from "./pages/SimulationPage";
import { PrivacyPage }       from "./pages/PrivacyPage";
import { TermsPage }         from "./pages/TermsPage";

function PageTracker() {
  const location = useLocation();
  const { user }  = useAuth();
  useEffect(() => {
    logPageLoad({
      path:      location.pathname + location.search,
      userEmail: user?.email || '',
    });
  }, [location.pathname, location.search]); // eslint-disable-line
  return null;
}

function App() {
  return (
    <>
    {/* Site-wide defaults — pages with their own Helmet override these.
        The Open Graph and Twitter card tags are deliberately left out here:
        react-helmet-async was keeping these five in place over the page-level
        overrides (title, description and canonical override correctly; these
        didn't), so every non-home page's share preview showed homepage copy.
        Pages with no Helmet of their own (privacy, terms) now fall back to
        index.html's og:type / og:site_name / og:image only. */}
    <Helmet>
      <title>Feuteuristix — Container Load Planning Intelligence</title>
      <meta name="description" content="Container load planning intelligence. Find the cheapest container combination and pack it perfectly — in one click." />
      <link rel="canonical" href="https://feuteuristix.com/" />
    </Helmet>
    <ScrollToTop />
    <PageTracker />
    <Routes>
      <Route path="/"                element={<HomePage />} />
      <Route path="/login"           element={<AuthPage />} />
      <Route path="/signup"          element={<Navigate to="/login?mode=signup" replace />} />
      <Route path="/cbm-calculator"  element={<CbmCalculatorPage />} />
      <Route path="/cbm"             element={<Navigate to="/cbm-calculator" replace />} />
      <Route path="/3d-cargo-load-simulator" element={<BeyondCbmPage />} />
      <Route path="/examples"        element={<ExamplesPage />} />
      <Route path="/pricing"         element={<PricingPage />} />
      <Route path="/developers"      element={<DevelopersPage />} />
      <Route path="/console"         element={<ConsolePage />} />
      <Route path="/case-studies"    element={<CaseStudiesPage />} />
      <Route path="/contact-sales"   element={<ContactSalesPage />} />
      <Route path="/solutions"       element={<SolutionsPage />} />
      <Route path="/technology"      element={<TechnologyPage />} />
      <Route path="/simulation"      element={<SimulationPage />} />
      <Route path="/privacy"         element={<PrivacyPage />} />
      <Route path="/terms"           element={<TermsPage />} />
      <Route path="*"                element={<Navigate to="/" replace />} />
    </Routes>
    </>
  );
}

export default App;
